export const constantsVariables = {
    state: [
        {
            name: 'Andaman and Nicobar Islands',
            value: 'AN'
        },
        {
            name: 'Andhra Pradesh',
            value: 'AP'
        },
        {
            name: 'Arunachal Pradesh',
            value: 'AR'
        },
        {
            name: 'Assam',
            value: 'AS'
        },
        {
            name: 'Bihar',
            value: 'BR'
        },
        {
            name: 'Chandigarh',
            value: 'CH'
        },
        {
            name: 'Chhattisgarh',
            value: 'CT'
        },
        {
            name: 'Delhi',
            value: 'DL'
        },
        {
            name: 'Dadra and Nagar Haveli and Daman and Diu',
            value: 'DN'
        },
        {
            name: 'Goa',
            value: 'GA'
        },
        {
            name: 'Gujarat',
            value: 'GJ'
        },
        {
            name: 'Himachal Pradesh',
            value: 'HP'
        },
        {
            name: 'Haryana',
            value: 'HR'
        },
        {
            name: 'Jharkhand',
            value: 'JH'
        },
        {
            name: 'Jammu and Kashmir',
            value: 'JK'
        },
        {
            name: 'Karnataka',
            value: 'KA'
        },
        {
            name: 'Kerala',
            value: 'KL'
        },
        {
            name: 'Ladakh',
            value: 'LA'
        },
        {
            name: 'Lakshadweep',
            value: 'LD'
        },
        {
            name: 'Maharashtra',
            value: 'MH'
        },
        {
            name: 'Meghalaya',
            value: 'ML'
        },
        {
            name: 'Manipur',
            value: 'MN'
        },
        {
            name: 'Madhya Pradesh',
            value: 'MP'
        },
        {
            name: 'Mizoram',
            value: 'MZ'
        },
        {
            name: 'Nagaland',
            value: 'NL'
        },
        {
            name: 'Odisha',
            value: 'OR'
        },
        {
            name: 'Punjab',
            value: 'PB'
        },
        {
            name: 'Puducherry',
            value: 'PY'
        },
        {
            name: 'Rajasthan',
            value: 'RJ'
        },
        {
            name: 'Sikkim',
            value: 'SK'
        },
        {
            name: 'Telangana',
            value: 'TG'
        },
        {
            name: 'Tamil Nadu',
            value: 'TN'
        },
        {
            name: 'Tripura',
            value: 'TR'
        },
        {
            name: 'Uttar Pradesh',
            value: 'UP'
        },
        {
            name: 'Uttarakhand',
            value: 'UT'
        },
        {
            name: 'West Bengal',
            value: 'WB'
        }
    ]
}